"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAiHubStrategyPath = exports.buildAiHubAdminSubTabPath = exports.buildAiHubTabPath = exports.normalizeAiHubLocation = exports.getAiHubStrategyId = exports.getAiHubAdminSubTab = exports.getAiHubTab = exports.getAiHubUseCaseId = exports.isAiHubUseCaseDetailsPath = exports.buildAiHubUseCaseDetailsPath = exports.buildAiHubDashboardPath = exports.DEFAULT_AI_HUB_ADMIN_SUB_TAB = exports.DEFAULT_AI_HUB_TAB = exports.AI_HUB_BASE_PATH = void 0;
exports.AI_HUB_BASE_PATH = '/deliver/ai';
exports.DEFAULT_AI_HUB_TAB = 'dashboard';
exports.DEFAULT_AI_HUB_ADMIN_SUB_TAB = 'strategy-builder';
var VALID_ADMIN_SUB_TABS = [
    'strategy-builder',
    'platform',
    'metrics',
    'security',
    'settings',
    'extraction',
    'users',
];
var createSearchParams = function (search) {
    if (search === void 0) { search = ''; }
    return new URLSearchParams(search.replace(/^\?/, ''));
};
var trimTrailingSlash = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    if (!pathname) {
        return exports.AI_HUB_BASE_PATH;
    }
    var trimmedPathname = pathname.replace(/\/+$/, '');
    return trimmedPathname || '/';
};
var getAiHubPathSegments = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    var normalizedPathname = trimTrailingSlash(pathname);
    if (normalizedPathname === exports.AI_HUB_BASE_PATH) {
        return [];
    }
    if ((normalizedPathname + "/").indexOf(exports.AI_HUB_BASE_PATH + "/") !== 0) {
        return [];
    }
    return normalizedPathname.slice(exports.AI_HUB_BASE_PATH.length).split('/').filter(Boolean);
};
var isValidAdminSubTab = function (value) {
    return !!value && VALID_ADMIN_SUB_TABS.indexOf(value) >= 0;
};
var getLegacyQueryTab = function (search) {
    if (search === void 0) { search = ''; }
    var tab = createSearchParams(search).get('tab');
    return tab === 'admin' ? 'admin' : exports.DEFAULT_AI_HUB_TAB;
};
var getLegacyQueryAdminSubTab = function (search) {
    if (search === void 0) { search = ''; }
    var subTab = createSearchParams(search).get('subTab');
    return isValidAdminSubTab(subTab) ? subTab : exports.DEFAULT_AI_HUB_ADMIN_SUB_TAB;
};
var getLegacyQueryStrategyId = function (search) {
    if (search === void 0) { search = ''; }
    var strategyIdValue = createSearchParams(search).get('strategyId');
    if (!strategyIdValue) {
        return null;
    }
    var parsedStrategyId = parseInt(strategyIdValue, 10);
    return Number.isNaN(parsedStrategyId) ? null : parsedStrategyId;
};
var buildAiHubAdminPath = function (subTab, strategyId) {
    if (subTab === void 0) { subTab = exports.DEFAULT_AI_HUB_ADMIN_SUB_TAB; }
    if (strategyId === void 0) { strategyId = null; }
    if (subTab !== 'strategy-builder') {
        return exports.AI_HUB_BASE_PATH + "/admin/" + subTab;
    }
    return strategyId === null
        ? exports.AI_HUB_BASE_PATH + "/admin/strategy-builder"
        : exports.AI_HUB_BASE_PATH + "/admin/strategy-builder/" + strategyId;
};
exports.buildAiHubDashboardPath = function () {
    return exports.AI_HUB_BASE_PATH + "/dashboard";
};
exports.buildAiHubUseCaseDetailsPath = function (useCaseId) {
    return exports.AI_HUB_BASE_PATH + "/use-cases/" + useCaseId;
};
exports.isAiHubUseCaseDetailsPath = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    var segments = getAiHubPathSegments(pathname);
    return segments[0] === 'use-cases' && !!segments[1];
};
/**
 * Extract the use case id from an AI Hub use case details path.
 * Returns null if the path does not point to a specific use case.
 */
exports.getAiHubUseCaseId = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    var segments = getAiHubPathSegments(pathname);
    if (segments[0] === 'use-cases' && segments[1]) {
        return segments[1];
    }
    return null;
};
/**
 * Get the active AI Hub top-level tab from the current path.
 * Falls back to legacy query-string state while old links are still in use.
 */
exports.getAiHubTab = function (pathname, search) {
    if (pathname === void 0) { pathname = ''; }
    if (search === void 0) { search = ''; }
    var segments = getAiHubPathSegments(pathname);
    if (segments[0] === 'admin') {
        return 'admin';
    }
    if (segments[0] === 'dashboard' || segments[0] === 'use-cases') {
        return 'dashboard';
    }
    return getLegacyQueryTab(search);
};
/**
 * Get the active AI Hub admin sub-tab from the current path.
 * Falls back to legacy query-string state while old links are still in use.
 */
exports.getAiHubAdminSubTab = function (pathname, search) {
    if (pathname === void 0) { pathname = ''; }
    if (search === void 0) { search = ''; }
    var segments = getAiHubPathSegments(pathname);
    if (segments[0] === 'admin' && isValidAdminSubTab(segments[1] || null)) {
        return segments[1];
    }
    return getLegacyQueryAdminSubTab(search);
};
/**
 * Read the selected strategy id from the current path.
 * Falls back to legacy query-string state while old links are still in use.
 */
exports.getAiHubStrategyId = function (pathname, search) {
    if (pathname === void 0) { pathname = ''; }
    if (search === void 0) { search = ''; }
    var segments = getAiHubPathSegments(pathname);
    if (segments[0] === 'admin' && segments[1] === 'strategy-builder') {
        var strategyIdValue = segments[2];
        if (!strategyIdValue) {
            return null;
        }
        var parsedStrategyId = parseInt(strategyIdValue, 10);
        return Number.isNaN(parsedStrategyId) ? getLegacyQueryStrategyId(search) : parsedStrategyId;
    }
    return getLegacyQueryStrategyId(search);
};
/**
 * Normalize any AI Hub URL into its canonical path-based form.
 * Also upgrades legacy query-string URLs to the new route structure.
 */
exports.normalizeAiHubLocation = function (pathname, search) {
    if (pathname === void 0) { pathname = ''; }
    if (search === void 0) { search = ''; }
    var normalizedPathname = trimTrailingSlash(pathname);
    var segments = getAiHubPathSegments(normalizedPathname);
    if (segments[0] === 'use-cases') {
        return segments[1] ? exports.buildAiHubUseCaseDetailsPath(segments[1]) : exports.buildAiHubDashboardPath();
    }
    if (segments[0] === 'dashboard') {
        return exports.buildAiHubDashboardPath();
    }
    if (segments[0] === 'admin') {
        var subTab = exports.getAiHubAdminSubTab(normalizedPathname, search);
        var strategyId = exports.getAiHubStrategyId(normalizedPathname, search);
        return buildAiHubAdminPath(subTab, strategyId);
    }
    var tab = exports.getAiHubTab(normalizedPathname, search);
    if (tab === 'admin') {
        return buildAiHubAdminPath(exports.getAiHubAdminSubTab(normalizedPathname, search), exports.getAiHubStrategyId(normalizedPathname, search));
    }
    return exports.buildAiHubDashboardPath();
};
/**
 * Build the next canonical AI Hub path for a top-level tab change.
 */
exports.buildAiHubTabPath = function (pathname, search, nextTab) {
    if (nextTab === 'admin') {
        return buildAiHubAdminPath(exports.getAiHubAdminSubTab(pathname, search));
    }
    return exports.buildAiHubDashboardPath();
};
/**
 * Build the next canonical AI Hub path for an admin sub-tab change.
 */
exports.buildAiHubAdminSubTabPath = function (pathname, search, nextSubTab) {
    if (nextSubTab === 'strategy-builder') {
        return buildAiHubAdminPath(nextSubTab, exports.getAiHubStrategyId(pathname, search));
    }
    return buildAiHubAdminPath(nextSubTab);
};
/**
 * Build the next canonical AI Hub path for a strategy selection change.
 */
exports.buildAiHubStrategyPath = function (strategyId) {
    return buildAiHubAdminPath('strategy-builder', strategyId);
};
